import React from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '../../../../StyledTypography';
import StarSolid from 'apollo-react-icons/StarSolid';
import FieldWrapper from '../../fields/FieldWrapper';
import HelperText from '../../fields/HelperText';
import styles from '../IDSField.module.css';

const RatingFieldInput = ({
  label,
  value,
  onChange,
  disabled,
  required,
  columnStyle,
  helperText,
  showError,
  max,
}) => {
  const { t } = useTranslation();
  const ratingValue = typeof value === 'number' ? value : 0;
  const maxRating = max || 5;

  const handleRatingClick = (starIndex) => {
    if (disabled) return;
    onChange(starIndex + 1);
  };

  return (
    <FieldWrapper style={columnStyle}>
      <Typography variant="bodySmall" className={styles.fieldLabel}>
        {label}
        {required && <span className={styles.requiredIndicatorRed}> *</span>}
      </Typography>
      <div className={styles.ratingContainer}>
        {Array.from({ length: maxRating }).map((_, index) => (
          <span
            key={index}
            onClick={() => handleRatingClick(index)}
            className={`${disabled ? styles.ratingStarDisabled : styles.ratingStar} ${
              index < ratingValue
                ? styles.ratingStarActive
                : styles.ratingStarInactive
            }`}
          >
            <StarSolid className={styles.starIcon} />
          </span>
        ))}
        <Typography
          variant="bodySmall"
          color="textSecondary"
          className={styles.ratingValue}
        >
          {ratingValue > 0 ? ratingValue : t('formRenderer.noRating')}
        </Typography>
      </div>
      <HelperText text={helperText} error={showError} />
    </FieldWrapper>
  );
};

export default RatingFieldInput;
